<template>
  <v-container>
    <v-form>
      <v-layout justify-center>
        <v-container>
          <v-layout>
            <v-flex>
              <boton-impresion></boton-impresion>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex></v-flex>
          </v-layout>
          <v-layout>
            <!-- <v-flex>
              <sub-proceso-impresion></sub-proceso-impresion>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import BotonImpresion from "@/modules/configuration/commonsviews/BotonesProcesoImpresion.vue";
import SubProcesoImpresion from "@/modules/impresion/views/proceso/SubProcesoImpresion.vue";

export default {
  components: {
    BotonImpresion,
    SubProcesoImpresion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    contratoId: "",
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
  },
  methods: {},
};
</script>
